import { computed, useSlots } from 'vue';

export function useTableColumns(appliedColumns) {
  const slots = useSlots();
  const shouldRenderTableColumns = computed(() => {
    return Array.isArray(appliedColumns.value) || slots['custom-actions']?.();
  });

  return { shouldRenderTableColumns };
}
